import { AgentsBoxCard } from '@motorway/motorway-handshake-components';

import { Header } from '../../components/Header/Header';
import { ReportCard } from '../../components/ReportCard/ReportCard';
import { VehicleSummary } from '../../components/VehicleSummary/VehicleSummary';
import { snowplowClick, snowplowCtaClick } from '../../helpers/snowplow';

export const Pending = () => (
  <div>
    <Header>
      <h1>Waiting for the seller to accept your inspection report</h1>
    </Header>
    <ReportCard />
    <AgentsBoxCard clickCallback={snowplowCtaClick} />
    <VehicleSummary clickCallback={snowplowClick} />
  </div>
);
